import React from 'react';
import { Typewriter } from 'react-simple-typewriter';

const Hero = () => {
  return (
    <section className="wn-hero">
      {/* Background video */}
      <video className="wn-hero-video" autoPlay loop muted playsInline>
        <source
          src={`${process.env.PUBLIC_URL}/hero-bg.mp4`}
          type="video/mp4"
        />
      </video>

      <div className="wn-hero-overlay" />

      <div className="wn-hero-content">
        <div className="wn-hero-eyebrow">YOUR FRACTIONAL CAO</div>
        <h1>
          Chief{' '}
          <span className="wn-gradient-text">
            <Typewriter
              words={['Agent', 'AI', 'Automation']}
              loop
              cursor
              cursorStyle="|"
              typeSpeed={90}
              deleteSpeed={60}
              delaySpeed={1600}
            />
          </span>{' '}
          Officer
        </h1>

        <p className="wn-hero-description">
          Your business was built on experience. We make it run on AI, too —
          implementing automation and ecommerce for legacy distributors, CPG
          companies, and family-owned businesses, with the change management
          that makes it stick and the ROI you can see on your P&amp;L.
        </p>

        <div className="wn-hero-buttons">
          <a
            href="#contact"
            className="wn-btn-primary"
            onClick={e => {
              e.preventDefault();
              document
                .getElementById('contact')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Book a Free Assessment →
          </a>
          <a
            href="#story"
            className="wn-btn-secondary"
            onClick={e => {
              e.preventDefault();
              document
                .getElementById('story')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            See the Topicz Story
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
